import { createContext, useContext, useState } from 'react';

const SessionContext = createContext(null);

export const SessionSubsidiaryProvider = ({ children }) => {
    const [subsidiarySession, setSubsidiarySession] = useState(() => {
        return localStorage.getItem('receptionSubsidiarySession');
    });

    const setSession = (key, value) => {
        localStorage.setItem(key, value);
        setSubsidiarySession(value);
    };

    return (
        <SessionContext.Provider value={{ subsidiarySession, setSession }}>
            {children}
        </SessionContext.Provider>
    );
};

export const useSubsidiarySession = () => useContext(SessionContext);